import { TaskCompletion, useTaskCompletionQuery } from 'graphql-common';
import { WatchQueryFetchPolicy } from '@apollo/client';
import { ApolloError } from '@apollo/client/errors';

type Args = {
  id: string;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
};

export type UseTaskCompletionQueryHookResult = {
  data: TaskCompletion | null | undefined;
  error: ApolloError | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useTaskCompletionQueryHook(
  args: Args,
): UseTaskCompletionQueryHookResult {
  const { id, skip, fetchPolicy = 'cache-and-network' } = args;
  const query = useTaskCompletionQuery({
    skip: !id || skip,
    variables: {
      id,
    },
    fetchPolicy,
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const taskCompletionData = data?.data as TaskCompletion;
  const firstLoading = loading && queryData === undefined;

  return {
    data: taskCompletionData,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
